import { SkillType, useListSkillsQuery } from '../generated/graphql';

// import TechnicalSkill, {
//  listMainSkillsWithOpenPositions, listTechnicalSkills } from '../models/technical-skills';

// function filterSkills(
//   skills: TechnicalSkill[],
//   area: Maybe<SkillArea>,
//   type: Maybe<SkillType>,
// ) {
//   let resultSkills: TechnicalSkill[] = skills;
//   if (area || type) {
//     resultSkills = R.filter(R.where({
//       area: (x: SkillArea | undefined) => (area ? x === area : true),
//       type: (x: SkillType | undefined) => (type ? x === type : true),
//     }), resultSkills);
//   }
//   return resultSkills;
// }

// type SkillsState = {
//   skills: TechnicalSkill[] | undefined;
//   fetching: boolean;
// };

export default function useTechSkills() {
  const { data, isLoading } = useListSkillsQuery({
    endpoint: 'https://bvxqmtw2tbeelktspfq4emau2i.appsync-api.us-east-1.amazonaws.com/graphql',
    fetchParams: {
      headers: {
        'x-api-key': 'da2-vfyl3e6445dadeuvbu3v5akrim',
      },
    },
  }, {
    type: SkillType.Main,
  }, {
    staleTime: Infinity,
  });
  return {
    skills: isLoading
      ? undefined
      : data?.listTechnicalSkills?.items?.sort((a, b) => a.name.localeCompare(b.name)),
    fetchingSkills: isLoading,
  };
}
